import { render, staticRenderFns } from "./ProfessionList.vue?vue&type=template&id=65d9ecba&"
import script from "./ProfessionList.vue?vue&type=script&lang=js&"
export * from "./ProfessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports